import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Container,Row, Col} from 'reactstrap';
import { ASSET_IMAGE } from '../../../../../../config'

export default class BankAccount extends Component{
    render(){
        return(
            <Container className="bank-account">
                <Row>
                    <Col xs={12} >
                        <KickImage className="img-responsive" alt={`${this.props.branch.toUpperCase()} Icon`} role="presentation" src={`${ASSET_IMAGE}/email/${this.props.bank_name.toLowerCase()}.png`}/>
                    </Col>
                    <Col xs={12}>
                        <p className="text-center" style={{marginBottom:0}}>
                            {this.props.account_name}<br/>
                            {/* {this.props.branch} */}
                        </p>
                        
                    </Col>
                    <Col xs={12}>
                        <p className="text-center text-bold">
                            {this.props.account_number}
                        </p>
                    </Col>
                    
                </Row>
            </Container>
        )
    }
}